<div>
  <ng-container *ngIf="this._DataHelper.cashoutSlipsList && this._DataHelper.cashoutSlipsList.length > 0">
    <ng-container *ngFor="let item of this._DataHelper.cashoutSlipsList">
      <cashout-new-slip
        [possibleWin]="item.PossibleGain"
        [slipType]="item.SlipType"
        [isLive]="getLiveAny(item.details)"
        [stake]="item.Amount"
        [matchData]="item.details"
        [slipIsOpen]="slipIsOpen"
        [slipID]="item.SlipId"
        [cashoutValue]="item.cashoutValue"
        (openSlip)="$event === slipIsOpen ? (slipIsOpen = '0') : (slipIsOpen = $event)"></cashout-new-slip>
    </ng-container>
  </ng-container>
</div>
